import React from "react";
import { doc } from "../MyPropertyDocuments/MyPropertyDocuments";
import DocListItem from "./DocListItem";

interface DocListProps {
    docSelect: (id: string, docName?: string) => void;
    loading: boolean;
    selectedDoc: string;
    docs: doc[];
}

export default function DocList(props: DocListProps){

    const currentProperty = window.localStorage.getItem("currentProperty");
    const isSmallDevice = window.innerWidth < 900;
    const docs = props.docs;
    
    const groupBy = (array: doc[] = []) => {
        const notices = []
        const profiles = []
        for (let i = 0; i < array.length; i++) {
            // separate profiles from notices in order to match profile with notice based on type and notice published date/profile date
            if (array[i].vendorproducttype === "PROFILE") {
                profiles.push(array[i])
            } else {
                notices.push(array[i])
            }
        }
        const docsArray = []
        for (const i in notices) {
            const noticeType = notices[i].vendorproducttype
            let noticeWithProfile = false
            // compare notice type/published date to each profile in profiles array
            // if notice and profile types match and notice published date/profile date are within 1 day, they are grouped together
            // to be displayed together under the same date
            for (const j in profiles) {
                const parts = profiles[j].id?.toString().split("_")
                const profileType = parts?.length ? parts[2] : ""
                let profileDate = parts?.length ? parts[1] : ""
                profileDate = profileDate?.length === 8 ? profileDate.substring(0, 4) + "-" + profileDate.substring(4, 6) + "-" + profileDate.substring(6, 8) : ""
                if (noticeType === profileType) {
                    const daysInSeconds = 60 * 60 * 24
                    const date1 = new Date(notices[i].publisheddate)
                    const date2 = new Date(profileDate)
                    const diffTime = Math.abs(date2.getTime() - date1.getTime())
                    const diffSeconds = diffTime / 1000
                    if (diffSeconds <= daysInSeconds) {
                        noticeWithProfile = true
                        const newArray = []
                        // add matched notice and profiles to same array and add this array to docs array
                        newArray.push(notices[i])
                        newArray.push(profiles[j])
                        docsArray.push(newArray)
                    }
                }
            }
            if (noticeWithProfile === false) {
                // if a notice is not matched with any profiles, add to the docs array by itself
                docsArray.push([notices[i]])
            }
        }
        return docsArray
    }

    const groupedDocs = groupBy(docs);
    const jsx = groupedDocs?.map((e: doc[] = [], i: number) => {
        const docWithFFE = e.filter(e => e.FFE)
        const FFE = docWithFFE.length ? docWithFFE[0].FFE : null
        return <div key={i}>
            {e.map((doc: doc, idx: number) => {
                console.log(doc)
                return <DocListItem
                    key={`${idx}${i}`}
                    isSelected={doc.id === props.selectedDoc} 
                    doc={doc} 
                    docSelect={props.docSelect} 
                    idx={idx}
                />
            })}
            {FFE && <div>
                <div className={"notice-container " + ("FFE_" + currentProperty?.substring(0, 15) + "_" + FFE?.publishedDate === props.selectedDoc ? "highlighted" : "")}>
                    <p className="report notice-title" onClick={() => {
                        const filename = "FFE_" + currentProperty?.substring(0, 15) + "_" + FFE?.publishedDate
                        props.docSelect("FFE", filename)
                    }}>
                        {FFE.type}
                    </p>
                    <hr className="report-hr" />
                </div>
            </div>}
        </div>
    });

    if (isSmallDevice) {
        return <div className="small-documents-scrollable">{jsx}</div>;
    } else {
        return <>{jsx}</>;
    }
}